/*
 * @Author       : qixiao
 * @Date         : 2023-05-15 18:53:28
 * @LastEditors  : qixiao
 * @LastEditTime : 2023-05-15 19:22:44
 * @FilePath     : \hzs-Houtai\src\store\modules\Agricultural.js
 * @Description  : 
 * 
 */

const state = {
    searchName:'',
    masterId:'',
  };
  const mutations = {
    changeSearchName(state, payload){
        state.searchName = payload
        console.log(state.searchName);
    },
    changeMasterId(state, payload){
        state.masterId = payload
    },
  };
  export default {
    namespaced: true,
    state,
    mutations,
  };
  